import React, { useRef, useState } from "react";
import "./index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import TrainSelector from "../components/TrainSelector";
import PlantInformation from "../pages/plantsPage/plantInformation";
import ReplacementResult from "../pages/replacementAdvisorPages/replacementResult";
import { useSelector } from "react-redux";
import Settings from "../pages/home/Settings";
import ReplacementThreshold from "../pages/replacementAdvisorPages/replacementThreshold";
import { useTranslation } from "react-i18next";

const raXLSFileUpload = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    activeStep,
    setActiveStep,
    isBackClicked,
    isNextClicked,
    setDisableNextButton,
    setSettingsButton,
  } = props;
  const file_id = useSelector((state) => state.file_id);
  const [noThresholdError, setNoThresholdError] = useState(true);
  const [mandatoryThresholdFilled, setMandatoryThresholdFilled] =
    useState(true);
  const [detailsResult, setDetailsResult] = useState(null);

  const fileRef = useRef(null);
  const plantRef = useRef(null);
  const settingsRef = useRef(null);
  const thresholdRef = useRef(null);

  const onNextClicked = async () => {
    setDetailsResult(false);
    if (noThresholdError) {
      if (settingsRef && settingsRef.current) {
        settingsRef.current.settingsInformation();
      }
      if (fileRef && fileRef.current) {
        fileRef.current.performanceData();
      }
      if (thresholdRef && thresholdRef.current) {
        thresholdRef.current.replacementThreshold();
      }
      if (plantRef && plantRef.current) {
        await plantRef.current.plantInformation();
      }
      // Trigger result fetch after PUT API completes
      setDetailsResult(true);
    }
  };

  React.useImperativeHandle(ref, () => ({ onNextClicked }));

  return (
    <div>
      <div className="flex-jc-center">
        <TrainSelector disabled={activeStep !== 0} app="ra" />
      </div>

      {activeStep === 0 && (
        <div className="uploadContainer">
          <div className="descriptionText">
            {t("plantInformationStrings.descriptionRA")}
          </div>
          <PlantInformation
            ref={plantRef}
            setActiveStep={setActiveStep}
            setDetailsResult={setDetailsResult}
            mandatoryThresholdFilled={mandatoryThresholdFilled}
            ra
          />
          <Settings
            ref={settingsRef}
            fileId={file_id}
            isBackClicked={isBackClicked}
            disabled={true}
          />
          <ReplacementThreshold
            ref={thresholdRef}
            setNoThresholdError={setNoThresholdError}
            setActiveStep={setActiveStep}
            setMandatoryThresholdFilled={setMandatoryThresholdFilled}
            isNextClicked={isNextClicked}
          />
        </div>
      )}
      {activeStep === 1 && (
        <ReplacementResult
          detailsResult={detailsResult}
          setDisableNextButton={setDisableNextButton}
          setSettingsButton={setSettingsButton}
        />
      )}
    </div>
  );
});

export default raXLSFileUpload;
